import { PlatformRoamingType } from '@manage/access-control/data/access-control.model';
import { IconCellData } from '@widgets/innogy-data-table/icon-cell/icon-cell.component';
import { LinkCellData } from '@widgets/innogy-data-table/link-cell/link-cell.component';
import { MenuItem } from '@widgets/menu-overlay/menu-overlay.component';

export enum EmaidStatus {
  ALL = '-1',
  INITIAL = 'INITIAL',
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}

export interface ContractBulkEditSelectFilter {
  search: string;
  status?: EmaidStatus;
  description?: string;
  reference?: string;
}

export interface ContractsFilter {
  status?: EmaidStatus;
  rfid?: string;
  description?: string;
  reference?: string;
}

export interface RfidRow {
  rfid: string;
  validFrom: string;
  validTo: string;
  originalData: Rfid;
}

export interface PagedEmaids {
  emaids: Emaid[];
  paging: Paging;
}

export interface Paging {
  currentPage?: number;
  totalPages?: number;
  itemsPerPage?: number;
  totalItems?: number;
}

export interface EmaidUpdate {
  password: string;
  description: string;
  customerReference: string;
  status: EmaidStatus;
}

export interface Emaid {
  emaid: string;
  description: string;
  customerReference: string;
  status: EmaidStatus;
  emaidGroupId: string;
  emaidGroupName: string;
  rfids: Rfid[];
  platformRoamingType: PlatformRoamingType;
  externalRoaming: boolean;
  modified: string;
  modifiedStatus: string;
  jobId: string;
  tariffId: string;
  tariffName: string;
}

export interface Rfid {
  rfid: string;
  validFrom: string;
  validTo: string;
}

export interface UpdateRfid {
  validFrom: string;
  validTo: string;
}

export interface EmaidRow {
  emaid: LinkCellData | string;
  description: string;
  rfids: string[];
  customerReference: string;
  status: IconCellData[];
  modified: string;
  access: { value: string }[];
  tariffName: string;
  roaming: boolean;
  externalRoaming: boolean;
  editable: boolean;
  notEditableTooltip: string;
  customActionEnabled: boolean;
  customActionNotEnabledTooltip: string;
  contractStatus: EmaidStatus;
  contractGroup: string[];
  data: Emaid;
  customActions?: MenuItem[];
}

export interface EmaidSelectionRow {
  id: string;
  emaid: LinkCellData | string;
  description: string;
  tariffName: string;
  customerReference: string;
  status: IconCellData[];
  emaidStatus: EmaidStatus;
  modified: string;
}

export interface CreateEmaids {
  amount: number;
  status: EmaidStatus;
  emaidGroupId: string;
  tariffId?: string;
}

export interface Partner {
  id: string;
  name: string;
  locations: Locations[];
  hasManageEmpRoaming: boolean;
  hasManageContractsEMarketplace: boolean;
  hasManageEmpTariffAssignment: boolean;
}

export interface Locations {
  id: string;
  uuid: string;
  name: string;
  defaultLocation: boolean;
}

export interface Tariff {
  id: string;
  name: string;
  tariffId: string;
  pricingVisibility: EPricingVisibility;
}

export enum EPricingVisibility {
  SHOW = 'SHOW',
  HIDE = 'HIDE',
}

export interface EditEmaidModalData {
  partnerId: string;
  emaid: string;
  description: string;
  customerReference: string;
  status: EmaidStatus;
}

export interface EditRfidsModalData {
  partnerId: string;
  emaid: string;
  hasManagePermission: boolean;
}

export interface EditRfidModalData {
  partnerId: string;
  emaid: string;
  rfid: Rfid;
  editMode: boolean;
}

export const rfidRegex = new RegExp(/^([0-9A-F]{8}|[0-9A-F]{14}|[0-9A-F]{20})$/);

export interface AssignTariffToEmaid {
  tariffId: string;
  validFrom: string;
}

export interface BulkUpdateEmaidsRequest {
  emaids: string[];
  status: EmaidStatus.ACTIVE | EmaidStatus.INACTIVE;
}
